/** Draft theme migration only. Preserve historical review text; route obsolete offer links to single bars. */
(() => {
  const retired = new Set(['/products/bar-soap-2-pack','/products/bar-soap-4-pack','/products/bar-soap-variety-pack','/products/beast-mode-value-pack']);
  const variants = {'51763053855036':'51210453778748','51763053887804':'51210453811516','51763053920572':'51210453844284','51763053953340':'51210453877052'};
  function replacement(href) {
    const url = new URL(href, location.origin);
    const productPath = url.pathname.replace(/\/$/, '').replace(/^\/collections\/[^/]+(?=\/products\/)/, '');
    if (url.origin !== location.origin || !retired.has(productPath)) return null;
    url.pathname = '/products/tallow-soap';
    const oldVariant = url.searchParams.get('variant');
    if (variants[oldVariant]) url.searchParams.set('variant', variants[oldVariant]);
    else url.searchParams.delete('variant');
    url.searchParams.delete('view');
    url.searchParams.delete('qv');
    return url.pathname + url.search + url.hash;
  }
  const direct = replacement(location.href);
  if (direct) { location.replace(direct); return; }
  let scheduled = false;
  function updateLinks() {
    scheduled = false;
    document.querySelectorAll('a[href*="/products/bar-soap-"],a[href*="/products/beast-mode-value-pack"]').forEach(link => {
      const target = replacement(link.href);
      if (target) link.setAttribute('href', target);
    });
  }
  updateLinks();
  new MutationObserver(() => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(updateLinks); }
  }).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['href']});
})();
